//NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import { Modal, CopiableText } from 'frontend-component-library';
import WrapInModal from 'Components/ModalWrapper';

export const MODAL_NAME = 'Share';

class ShareModal extends PureComponent {
  render() {
    const { closeModal, resultsLink } = this.props;
    return (
      <React.Fragment>
        <Modal.Header closeModal={closeModal}>
          <h2>Share Results</h2>
        </Modal.Header>
        <Modal.Section>
          <div className="ShareModal-section-inner">
            <CopiableText
              textToCopy={resultsLink}
              labelText="Use the link below to share your top results with family or friends"
            />
          </div>
        </Modal.Section>
      </React.Fragment>
    );
  }
}

ShareModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  resultsLink: PropTypes.string.isRequired,
};

ShareModal.defaultProps = {
  resultsLink: '',
};

export default WrapInModal(ShareModal, MODAL_NAME);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ShareModal.js